/*jslint white: true, nomen: true */
/*global angular, $, communityId */
(function () {
  "use strict";

  angular
    .module("app.microsite")
    .controller("MicrositeCtrl", [
      "$scope",
      "$http",
      "DeviceService",
      "dummyDataService",
      "TourService",
      "$window",
      "$timeout",
      "$filter",
      "slickConfigService",
      "$rootScope",
      "regionStorageFactory",
      function (
        $scope,
        $http,
        DeviceService,
        dummyDataService,
        TourService,
        $window,
        $timeout,
        $filter,
        slickConfigService,
        $rootScope,
        regionStorageFactory,
      ) {
        var loadedOnce = false;

        $scope.communityLoaded = false;
        $scope.community = [];
        slickConfigService.modalSlideshow($scope);
        slickConfigService.baseConfig($scope);
        $scope.triggerSlick = false;
        $scope.plansForUser = [];
        $scope.homesForUser = [];
        $scope.residencesForUser = [];


        if (DeviceService.check() == "phone") {
          $scope.isCollapsed = true;
        } else {
          $scope.isCollapsed = false;
        }

        $scope.filteredResidences = [];

        $scope.sortColumn = "";
        $scope.sortName = "";
        $scope.sortReverse = true;

        $scope.toggleType = function (kind, order) {
          $scope.sortColumn = kind;
          $scope.sortReverse = order;
          $scope.updateSortName();
        };

        $scope.sortsParams = [
          {
            name: "Sort By...",
            value: {
              type: "",
              descending: true,
            }
          },
          {
            name: "By Highest Price",
            value: {
              type: "price",
              descending: true,
            },
          },
          {
            name: "By Lowest Price",
            value: {
              type: "price",
              descending: false,
            },
          },
          {
            name: "By Most Bedrooms",
            value: {
              type: "plan.bed_high",
              descending: true,
            },
          },
          {
            name: "By Least Bedrooms",
            value: {
              type: "plan.bed_low",
              descending: false,
            },
          },
          {
            name: "By Highest Sq. Ft.",
            value: {
              type: "plan.sqft_high",
              descending: true,
            },
          },
          {
            name: "By Lowest Sq. Ft.",
            value: {
              type: "plan.sqft_low",
              descending: false,
            },
          },
        ];

        $scope.$watch('[sortColumn, sortReverse]', function() {
         // Apply sorting after filtering
          $scope.applyResidenceSort();
      });

        $scope.applyResidenceSort = function() {
          $timeout(function() {

            if ($scope.filteredResidences && $scope.filteredResidences.length > 0) {

              if ($scope.community.id === 942 && $scope.sortColumn === 'collection') {
                var collectionOrder = {
                  23: 0, // Townhomes
                  7: 1,  // Maple Street
                  9: 2   // Designer
                };

                $scope.filteredResidences.sort(function (a, b) {
                  var aCollectionId = a && a.plan ? a.plan.collection_id : 999;
                  var bCollectionId = b && b.plan ? b.plan.collection_id : 999;

                  var aRank = collectionOrder.hasOwnProperty(aCollectionId)
                    ? collectionOrder[aCollectionId]
                    : 999;

                  var bRank = collectionOrder.hasOwnProperty(bCollectionId)
                    ? collectionOrder[bCollectionId]
                    : 999;

                  if (aRank !== bRank) {
                    return aRank - bRank;
                  }

                  return (b.price || 0) - (a.price || 0);
                });

                return;
              }

              $scope.filteredResidences.sort(function(a, b) {
                var aValue, bValue;

                // Get the values to compare based on sortColumn
                switch ($scope.sortColumn) {
                  case "price":
                    aValue = a.price;
                    bValue = b.price;
                    break;
                  case "plan.bed_high":
                    // For descending, use _high values
                    if ($scope.sortReverse) {
                      aValue = a.plan.bed_high || a.plan.bed_low || 0;
                      bValue = b.plan.bed_high || b.plan.bed_low || 0;
                    } else {
                      // For ascending, use _low values
                      aValue = a.plan.bed_low || a.plan.bed_high || 0;
                      bValue = b.plan.bed_low || b.plan.bed_high || 0;
                    }
                    break;
                  case "plan.bed_low":
                    // For descending, use _high values
                    if ($scope.sortReverse) {
                      aValue = a.plan.bed_high || a.plan.bed_low || 0;
                      bValue = b.plan.bed_high || b.plan.bed_low || 0;
                    } else {
                      // For ascending, use _low values
                      aValue = a.plan.bed_low || a.plan.bed_high || 0;
                      bValue = b.plan.bed_low || b.plan.bed_high || 0;
                    }
                    break;
                  case "plan.sqft_high":
                    // For descending, use _high values
                    if ($scope.sortReverse) {
                      aValue = a.plan.sqft_high || a.plan.sqft_low || 0;
                      bValue = b.plan.sqft_high || b.plan.sqft_low || 0;
                    } else {
                      // For ascending, use _low values
                      aValue = a.plan.sqft_low || a.plan.sqft_high || 0;
                      bValue = b.plan.sqft_low || b.plan.sqft_high || 0;
                    }
                    break;
                  case "plan.sqft_low":
                    // For descending, use _high values
                    if ($scope.sortReverse) {
                      aValue = a.plan.sqft_high || a.plan.sqft_low || 0;
                      bValue = b.plan.sqft_high || b.plan.sqft_low || 0;
                    } else {
                      // For ascending, use _low values
                      aValue = a.plan.sqft_low || a.plan.sqft_high || 0;
                      bValue = b.plan.sqft_low || b.plan.sqft_high || 0;
                    }
                    break;
                  default:
                    // Make values equal, the order will not change
                    aValue = 0;
                    bValue = 0;
                }

                // Handle cases where both values are 0 - they should come last
                if (aValue === 0 && bValue === 0) {
                  return 0; // Keep original order
                } else if (aValue === 0) {
                  return 1; // a comes last
                } else if (bValue === 0) {
                  return -1; // b comes last
                }

                // Apply sorting
                if ($scope.sortReverse) {
                  return bValue - aValue; // Descending
                } else {
                  return aValue - bValue; // Ascending
                }
              });
            }
          }, 50)
        };

        $scope.updateSortName = function () {
          let matchingSortParam = $scope.sortsParams.find(function (param) {
            return (
              param.value.type === $scope.sortColumn &&
              param.value.descending === $scope.sortReverse
            );
          });

          $scope.sortName = matchingSortParam ? matchingSortParam.name : "";
        };

        $scope.updateSortName();
        $scope.filtersParams = {
          bed: [],
          bath: [],
          price: [],
          type: [],
          collection: [],
          stories: [],
        };

        $scope.filters = {
          price: "all",
          bed: "all",
          bath: "all",
          type: "all",
          collection: "all",
          stories: "all",
        };

        $scope.specAggregates = {
          bed: [],
          bath: [],
          price: [],
          type: [],
          collection: [],
        };

        var defaults = {
          filterParam: {
            name: "All",
            value: "all",
          },
        };

        $scope.filtersParams.price.push(defaults.filterParam);
        $scope.filtersParams.bed.push(defaults.filterParam);
        $scope.filtersParams.bath.push(defaults.filterParam);
        $scope.filtersParams.type.push(defaults.filterParam);
        $scope.filtersParams.collection.push(defaults.filterParam);

        $scope.$watch(
          "filters",
          function (filters, oldFilters) {
            if (filters === oldFilters) {
              return;
            }
            $scope.filteredResidences = $filter("residenceFilter")(
              $scope.community.residences,
              $scope.filters
            );

          },
          true
        );

      
        $scope.communityPromise = $http.get(`/api/community/${communityId}`, { cache: true }).then(function (response) {
          const community = response.data.community;

          $scope.$broadcast("user-selected-community", community);
          $rootScope.community = community;
          regionStorageFactory.setRegion(community.region);
          $scope.tourMatch = community.model_homes.find((model_home) => {
            const hours = model_home.detailed_sales_office_hours;
            return hours && Object.values(hours).some(v => v !== null && v !== '');
          });

          if ($scope.tourMatch) {
            $scope.tourAvailability = $scope.tourMatch.detailed_sales_office_hours;

            if(community.region_id === 16){
              $scope.sp1Checks($scope.tourMatch);
            }

            $scope.tourLocation = $scope.tourMatch.model_location;
            $scope.allowToday = TourService.availableToday($scope.tourAvailability);
            $scope.tourTimes = TourService.generateWeeklyTourTimes($scope.tourAvailability);
            $scope.formattedTourTimes = TourService.formatTourTimes($scope.tourTimes);
          } else {
            $scope.tourLocation = {
                address: community.address ? community.address : '',
                city: community.city ? community.city : '',
                state: community.state ? community.state : '',
                zip: community.zip ? community.zip : '',
              }
          }

          $scope.plansForUser = community.plans_for_user;
          $scope.homesForUser = community.homes_for_user;
          $scope.residencesForUser = community.residences_for_user;
          // deactivated so that images are not being rendered in /resources/views/components/modal-gallery-details.blade.php
          // $scope.images = community.assets;

          // Build the modal asset list from a gallery payload (videos + assets),
          // applying the same special-case ordering as the legacy template.
          function buildGalleryAssets(galleryData) {
            var videos = (galleryData && galleryData.videos) ? galleryData.videos : [];
            var assets = (galleryData && galleryData.assets) ? galleryData.assets : [];
            var combined = videos.concat(assets);
            var firstAsset = null;

            if (
              galleryData &&
              (galleryData.collection_id == 18 || galleryData.collection_id == 20) &&
              videos.length > 0
            ) {
              firstAsset = combined[0];
              combined = combined.slice(1);
            }

            return { assets: combined, firstAsset: firstAsset };
          }

          // galleryThumbs powers the main gallery section and is intentionally
          // stable so the slick carousels do not get re-rendered with a new
          // slide count after the modal data is fetched.
          var initialGallery = buildGalleryAssets(community);
          $scope.galleryThumbs = initialGallery.assets;
          $scope.firstAsset = initialGallery.firstAsset;

          // newAssets is bound to the modal slick. It starts with the same
          // lightweight payload, then gets replaced with the full list the
          // first time the user opens the modal.
          $scope.newAssets = initialGallery.assets;

          $scope.communityGalleryPromise = null;
          $scope.loadCommunityGallery = function () {
            if ($scope.communityGalleryPromise) {
              return $scope.communityGalleryPromise;
            }

            $scope.communityGalleryPromise = $http
              .get(`/api/community-gallery/${communityId}`)
              .then(function (response) {
                var fullGallery = buildGalleryAssets(response.data);
                $scope.newAssets = fullGallery.assets;
                if (fullGallery.firstAsset) {
                  $scope.firstAsset = fullGallery.firstAsset;
                }

                return $scope.newAssets;
              });

            return $scope.communityGalleryPromise;
          };

          $scope.regionPhone = community.region.sales_phone;

          angular.forEach(community.model_homes, function (model_home) {
            if (typeof model_home.plan !== "undefined" && !!model_home.plan) {
              model_home.plan.url = model_home.url;
              delete model_home.plan.elevations;
            } else {
              model_home.plan = {};
            }

            model_home.plan.beds =
              model_home.plan.bed_low == model_home.plan.bed_high
                ? model_home.plan.bed_high
                : model_home.plan.bed_low + "-" + model_home.plan.bed_high;
            model_home.plan.baths =
              model_home.plan.bath_low == model_home.plan.bath_high
                ? model_home.plan.bath_high
                : model_home.plan.bath_low + "-" + model_home.plan.bath_high;
            model_home.plan.sqft =
              model_home.plan.sqft_low == model_home.plan.sqft_high
                ? model_home.plan.sqft_high
                : model_home.plan.sqft_low + "-" + model_home.plan.sqft_high;
          });

          if(community.model_homes.length > 1){
            $scope.slickModels = slickConfigService.baseConfig(1);
            $scope.slickModels.dots = true;
            $scope.slickModels.arrows = false;
            $scope.slickModels.adaptiveHeight = false;
          }

          // Sorting so that models located in the community and with open hours come first
          if (Array.isArray(community.model_homes) && community.model_homes.length > 1) {
            community.model_homes.sort(function(a, b) {
              var aHasHours = !!(a && a.sales_office_hours);
              var bHasHours = !!(b && b.sales_office_hours);

              if (aHasHours && !bHasHours) return -1;
              if (!aHasHours && bHasHours) return 1;

              if (aHasHours && bHasHours) {
                var aMatch = (a && community && a.community_located_id === community.id);
                var bMatch = (b && community && b.community_located_id === community.id);

                if (aMatch && !bMatch) return -1;
                if (!aMatch && bMatch) return 1;
              }

              return 0;
            });
          }


          var shortPrice =
            community.price < 1000000
              ? Math.floor(community.price / 1000 / 10) * 10
              : Math.floor(community.price / 1000000);

          community.short_price = shortPrice;

          $scope.short_price = community.short_price;

          if (
            community.homes.length > 0 &&
            $window.location.href.includes("move-in-ready")
          ) {
            $scope.isFloorplanActive = false;
          } else {
            $scope.isFloorplanActive = community.residences.length > 0;
          }

          $scope.toggleView = function (value) {
            $scope.isFloorplanActive = value;
          };

          // unique order/sort floorplans/residences by price asc (Renaissance - Franklin City Schools, community ID 274)
          // unique order/sort floorplans/residences by price asc (Twelve Oaks, community ID 795)
          // unique order/sort floorplans/residences by price asc (Silverstone, community ID 847)
          // unique order/sort floorplans/residences by price asc (Crossvine Estates, community ID 872)
          // unique order/sort floorplans/residences by price asc (The Cove, community ID 883)
          // unique order/sort floorplans/residences by price asc (Laurel Farms, community ID 885)
          // unique order/sort floorplans/residences by price asc (Laurel Farms, community ID 905)
          // unique order/sort floorplans/residences by price asc (Skybrook, community ID 884)
          // unique order/sort floorplans/residences by price asc (Parkrose, community ID 925)
          if (
            community.id === 274 ||
            community.id === 795 ||
            community.id === 847 ||
            community.id === 872 ||
            community.id === 883 ||
            community.id === 885 ||
            community.id === 905 ||
            community.id === 884 ||
            community.id === 925
          ) {
            $scope.sortReverse = false;
            $scope.sortName = "By Lowest Price";
            $scope.sortColumn = 'price';
          }

          // unique order/sort floorplans/residences by collection order, then price desc (Serenity Woods, community ID 942)
          if (community.id === 942) {
            $scope.sortName = "By Collection";
            $scope.sortColumn = "collection";
            $scope.sortReverse = true;
          }

          angular.forEach(community.residences, function (residence) {
            residence.plan.price = residence.price;
            residence.plan.url =
              community.url + residence.plan.url.substring(1);

            $scope.specAggregates.price.push(residence.price);
            $scope.specAggregates.bed.push(residence.plan.bed_low);
            $scope.specAggregates.bed.push(residence.plan.bed_high);
            $scope.specAggregates.bath.push(residence.plan.bath_low);
            $scope.specAggregates.bath.push(residence.plan.bath_high);

            if (
              typeof residence.plan.productType !== "undefined" &&
              residence.plan.productType
            ) {
              $scope.specAggregates.type.push(residence.plan.productType.name);
            }

            if (
              typeof residence.plan.collection !== "undefined" &&
              residence.plan.collection
            ) {
              $scope.specAggregates.collection.push(
                residence.plan.collection.name
              );
            }

            if (!$scope.specAggregates.stories) {
              $scope.specAggregates.stories = [];
            }

            if (typeof residence.plan.floors !== "undefined") {
              $scope.specAggregates.stories.push(residence.plan.floors);
            }

            residence.plan.beds =
              residence.plan.bed_low + "-" + residence.plan.bed_high;
            residence.plan.baths =
              residence.plan.bath_low + "-" + residence.plan.bath_high;
            residence.plan.sqft =
              residence.plan.sqft_low + "-" + residence.plan.sqft_high;
          });

          Object.keys($scope.specAggregates).forEach(function (key) {
            switch (key) {
              case "price":
                var minPrice = Math.min.apply(null, $scope.specAggregates[key]);
                var maxPrice = Math.max.apply(null, $scope.specAggregates[key]);
                minPrice = Math.ceil(minPrice / 100000) * 100000;
                maxPrice = Math.ceil(maxPrice / 100000) * 100000;

                for (var i = minPrice; i <= maxPrice; i += 100000) {
                  $scope.filtersParams.price.push({
                    name: "Under $" + i.toLocaleString(),
                    value: i,
                  });
                }
                break;

              case "bed":
                var minBeds = Math.min.apply(null, $scope.specAggregates[key]);
                var maxBeds = Math.max.apply(null, $scope.specAggregates[key]);

                for (var i = minBeds; i <= maxBeds; i++) {
                  $scope.filtersParams.bed.push({
                    name: i + "+",
                    value: i,
                  });
                }
                break;
              case "bath":
                var minBaths = Math.min.apply(null, $scope.specAggregates[key]);
                var maxBaths = Math.max.apply(null, $scope.specAggregates[key]);

                for (var i = minBaths; i <= maxBaths; i++) {
                  $scope.filtersParams.bath.push({
                    name: i + "+",
                    value: i,
                  });
                }
                break;
              case "type":
                $scope.specAggregates[key] = _.uniq($scope.specAggregates[key]);
                $scope.specAggregates[key].sort();
                angular.forEach($scope.specAggregates[key], function (item) {
                  $scope.filtersParams.type.push({
                    name: item,
                    value: item,
                  });
                });
                break;
              case "collection":
                $scope.specAggregates[key] = _.uniq($scope.specAggregates[key]);
                $scope.specAggregates[key].sort();
                angular.forEach($scope.specAggregates[key], function (item) {
                  let minSqft = Infinity;
                  let maxSqft = -Infinity;
                  let minBeds = Infinity;
                  let maxBeds = -Infinity;
                  let minBaths = Infinity;
                  let maxBaths = -Infinity;
                  let minPrice = Infinity;

                  community.residences.forEach((residence) => {
                    try {
                      if (residence.plan.collection.name === item) {
                        minSqft = Math.min(minSqft, residence.plan.sqft_low);
                        maxSqft = Math.max(maxSqft, residence.plan.sqft_high);
                        minBeds = Math.min(minBeds, residence.plan.bed_low);
                        maxBeds = Math.max(maxBeds, residence.plan.bed_high);
                        minBaths = Math.min(minBaths, residence.plan.bath_low);
                        maxBaths = Math.max(maxBaths, residence.plan.bath_high);
                        if (residence.plan.price < minPrice) {
                          minPrice = Math.min(minPrice, residence.plan.price);
                        }
                      }
                    } catch (error) {
                      console.error(
                        "An error occurred with the collection filter: ",
                        error
                      );
                    }
                  });

                  let homeCopy;
                  if (item == "Paired Patio Homes Collection") {
                    homeCopy = "Paired Patio Homes";
                  } else if (item === "Patio Homes Collection") {
                    homeCopy = "Patio Homes";
                  } else if (item === "Midtown Collection") {
                    homeCopy = "Townhomes";
                  } else {
                    homeCopy = "Single Family Homes";
                  }
                  $scope.filtersParams.collection.push({
                    name: item,
                    value: item,
                    bedRange: `${minBeds}-${maxBeds}`,
                    bathRange: `${minBaths}-${maxBaths}`,
                    sqftRange: `${minSqft}-${maxSqft}`,
                    price: minPrice,
                    copy: `${homeCopy} Priced From ${Intl.NumberFormat(
                      "en-US",
                      {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }
                    ).format(minPrice)}`,
                  });
                });
                $scope.filtersParams.collection.sort((a, b) => {
                  return b.price - a.price;
                });
                break;
              case "stories":
                $scope.specAggregates[key] = _.uniq($scope.specAggregates[key]);
                $scope.specAggregates[key].sort();
                angular.forEach($scope.specAggregates[key], function (item) {
                  $scope.filtersParams.stories.push({
                    name: item + " Story",
                    value: item,
                  });
                });
                break;
            }
          });

          $scope.filteredResidences = $filter("residenceFilter")(
            community.residences,
            $scope.filters
          );

          var birdeyeIds = dummyDataService.birdeyeIds();
          var birdeyeMatch = birdeyeIds.find(entry => entry.regionIds.includes(community.region_id));
          $scope.birdeyeId = birdeyeMatch ? birdeyeMatch.birdeyeId : null;
          $scope.showBirdeye = false;

          if ($scope.birdeyeId) {
            $scope.showBirdeye = true;
            var script = document.createElement('script');
            script.src = 'https://birdeye.com/embed/v7/' + $scope.birdeyeId + '/7/9876543214715183';
            script.async = true;
            document.querySelector('.birdeye-container').appendChild(script);
          }


          $scope.$broadcast("communityDataLoaded", community);
          $scope.community = community;

          $scope.getHomeTypes = function () {
            const collection = $scope.community.collection.name;
            const homeTypeMap = [
              ["Patio Homes Collection", "Patio Homes"],
              ["Midtown Collection", "Townhomes"],
              ["Paired Patio Homes Collection", "Paired Patio Homes"],
              ["Villa II Collection", "Condominiums"],
              ["Gallery II Collection", "Condominiums"],
            ];
            const matchingType = homeTypeMap.find(
              (subArray) => subArray[0] === collection
            );
            return matchingType ? matchingType[1] : "Homes";
          };
          $scope.isMobile = function () {
            return window.innerWidth <= 768;
          };
          $scope.displayLimit = $scope.isMobile() ? 3 : 6;
          $scope.loadMoreFloorplans = function (count) {
            $scope.displayLimit += count;
          };
          $scope.communityLoaded = true;
          $scope.contextData = {
            type: "tour",
            community: $scope.community,
            specialistTours: $scope.tourMatch ? true : false,
          }
          $rootScope.$broadcast('contextDataLoaded', $scope.contextData);
          return $scope.communities;
        });

        $scope.communityGalleryPromise = $http.get(`/api/community-gallery/${communityId}`).then(function (response) {
          const communityGallery = response.data;
          // merge videos and assets
          $scope.firstAsset = null;
          $scope.newAssets = communityGallery.videos.concat(communityGallery.assets);
          // Hardcoded for specific collections moved from
          // resources/views/microsite/partials/image-gallery.blade.php
        
            if (
            (communityGallery.collection_id == 18 || communityGallery.collection_id == 20) &&
            communityGallery.videos.length > 0
          ) {
            $scope.firstAsset = $scope.newAssets[0];
            $scope.newAssets = $scope.newAssets.slice(1);
          }
        });

       

        $scope.active = 0;

        $scope.featuredFloorplan = [];

        $scope.sp1Checks = function(modelHome){
          if(modelHome.sales_office_hours){
            $scope.tourAvailability = $scope.tourAvailability || {};
            $scope.tourAvailability.showcase = true;
            $scope.tourAvailability.showcase_days = dummyDataService.daytonTourTimes().showcase_days ? dummyDataService.daytonTourTimes().showcase_days : [];
            $scope.tourAvailability.showcase_start = dummyDataService.daytonTourTimes().showcase_start;
            $scope.tourAvailability.showcase_end = dummyDataService.daytonTourTimes().showcase_end;
          };
        }

        $scope.selectFilter = function (type, value) {
          $scope.filters[type] = value;
        };

        $scope.filterByStory = function (storyCount) {
          if (storyCount === 1) {
            if ($scope.filters.stories && $scope.filters.stories.value === 1) {
              $scope.filters.stories = {};
            } else {
              $scope.filters.stories = { value: 1 };
            }
          } else if (storyCount === "multi") {
            if (
              $scope.filters.stories &&
              $scope.filters.stories.value === "multi"
            ) {
              $scope.filters.stories = {};
            } else {
              $scope.filters.stories = { value: "multi" };
            }
          } else {
            $scope.filters.stories = {};
          }
        };

        $scope.triggerSlick = false;
        $rootScope.$on("modalClose", function () {
          $scope.triggerSlick = false;
        });

        $scope.setSlide = function (num) {
          if (!$scope.triggerSlick) {
            $scope.slickLarge.initialSlide = num;
            $scope.slickLarge.event = {
              beforeChange: function (event, slick, currentSlide, nextSlide) {
                var player, command;

                player = $("iframe", slick.$slides[currentSlide])[0];

                // for youtube, don't forget to add the parameter enablejsapi=1 to the url of the video
                if ($(slick.$slides[currentSlide]).hasClass("youtube")) {
                  command = {
                    event: "command",
                    func: "pauseVideo",
                  };
                } else if ($(slick.$slides[currentSlide]).hasClass("vimeo")) {
                  command = {
                    method: "pause",
                    value: "true",
                  };
                }

                //check if the player exists.
                if (player != undefined) {
                  // post our command to the iframe.
                  player.contentWindow.postMessage(
                    JSON.stringify(command),
                    "*"
                  );
                }
              },
            };
            $scope.triggerSlick = true;
          }
        };

        $scope.lastScrollTop = 0;
        $scope.scrollDirection = "up";
        angular.element($window).bind("scroll", function () {
          var currentScrollTop = window.pageYOffset;
          // Preventing navbar from collapsing on mobile if user can see the header.
          if (currentScrollTop <= 50) {
            $scope.scrollDirection = "up";
            $scope.isCollapsed = false;
          } else {
            if (
              currentScrollTop > $scope.lastScrollTop &&
              DeviceService.check() == "phone"
            ) {
              $scope.scrollDirection = "down";
              var $toggle = $("#subnav .navbar-toggle");
              if (!$toggle.hasClass("collapsed")) {
                $toggle.click();
              }
            } else {
              $scope.scrollDirection = "up";
            }
          }

          $scope.lastScrollTop = currentScrollTop;
          $scope.$apply();
        });
        $scope.someFunction = function () {
          $scope.broadcast("triggerModal");
        };
      },
    ])
    .filter("residenceFilter", function () {
      return function (residences, filters) {
        return residences.filter(function (residence) {
          var valid = true;

          Object.keys(filters).forEach(function (key) {
            if (filters[key]["value"] && filters[key]["value"] !== "all") {
              switch (key) {
                case "bed":
                  if (
                    filters[key]["value"] < residence.plan.bed_low ||
                    filters[key]["value"] > residence.plan.bed_high
                  ) {
                    valid = false;
                  }
                  break;
                case "bath":
                  if (
                    filters[key]["value"] < residence.plan.bath_low ||
                    filters[key]["value"] > residence.plan.bath_high
                  ) {
                    valid = false;
                  }
                  break;
                case "price":
                  if (residence.price > filters[key]["value"]) {
                    valid = false;
                  }
                  break;
                case "type":
                  if (
                    residence.plan.productType.name != filters[key]["value"]
                  ) {
                    valid = false;
                  }
                  break;
                case "collection":
                  if (
                    sget(["plan", "collection", "name"], residence) !=
                    sget([key, "value"], filters)
                  ) {
                    valid = false;
                  }
                  break;
                case "stories":
                  if (filters[key] && filters[key]["value"] === "multi") {
                    if (residence.plan.floors <= 1) {
                      valid = false;
                    }
                  } else if (
                    filters[key] &&
                    residence.plan.floors !== filters[key]["value"]
                  ) {
                    valid = false;
                  }
                  break;
              }
            }
          });

          return valid;
        });
      };
    });
})();
